import Quill from 'quill'

const Link = Quill.import('formats/link')

class LinkBlot extends Link {
  static create(value) {
    const node = super.create()

    if (value) {
      const absoluteUrl = LinkBlot.ensureAbsoluteUrl(value)
      node.setAttribute('href', absoluteUrl)
    }

    return node
  }

  static formats(node) {
    const href = node.getAttribute('href')
    // Return normalized URL when reading format
    return LinkBlot.ensureAbsoluteUrl(href)
  }

  format(name, value) {
    if (name !== this.statics.blotName || !value) {
      super.format(name, value)
    } else {
      // Ensure URL is absolute when formatting
      const absoluteUrl = LinkBlot.ensureAbsoluteUrl(value)
      this.domNode.setAttribute('href', absoluteUrl)
    }
  }

  static ensureAbsoluteUrl(url) {
    if (!url) return url

    url = url.trim()

    if (/^https?:\/\//i.test(url)) {
      return url
    }

    if (url.startsWith('//')) {
      return `https:${url}`
    }

    if (url.startsWith('/')) {
      return `https://${url}`
    }

    return `https://${url}`
  }
}

LinkBlot.blotName = 'link'
LinkBlot.tagName = 'a'

Quill.register(LinkBlot, true)
